export function* iterate(object) {
	for(let key of Object.keys(object)) {
		yield [key, object[key]];
	}
}

export const ObjectIterator = {
	iterate
};

export default ObjectIterator;
